import React from 'react';
import { Provider } from 'react-redux';
import { browserHistory, Router } from 'react-router';

import { configureStore } from './redux';
import routes from './routes';

import { Provider as MediaProvider } from '../researcher/blocks/media';

const ParticipantApp = React.memo(() => {
  const store = React.useMemo(() => configureStore(), []);
  const appRoutes = React.useMemo(() => routes(), []);

  return (
    <Provider store={store}>
      <MediaProvider>
        <Router history={browserHistory} routes={appRoutes} />
      </MediaProvider>
    </Provider>
  );
});

export default ParticipantApp;
